import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TooltipItem,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import type { FeaturesData } from '../../lib/types'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface FeatureBreakdownChartProps {
  data: FeaturesData
}

const COLORS = [
  'hsl(222.2, 47.4%, 11.2%)',
  'hsl(215.4, 16.3%, 46.9%)',
  'hsl(210, 40%, 60%)',
  'hsl(200, 50%, 50%)',
  'hsl(180, 40%, 45%)',
  'hsl(160, 50%, 40%)',
  'hsl(140, 45%, 45%)',
  'hsl(120, 40%, 50%)',
]

export function FeatureBreakdownChart({ data }: FeatureBreakdownChartProps) {
  // Group by feature
  const features = [...new Set(data.map((d) => d.feature))]

  const chartData = {
    labels: data.slice(0, 15).map((d) => `${d.feature}: ${d.action}`),
    datasets: [
      {
        label: 'Events',
        data: data.slice(0, 15).map((d) => d.count),
        backgroundColor: data
          .slice(0, 15)
          .map((d) => COLORS[features.indexOf(d.feature) % COLORS.length]),
        borderWidth: 0,
        borderRadius: 4,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<'bar'>) => {
            const item = data[context.dataIndex]
            return `${item.count.toLocaleString()} events (${item.percentage.toFixed(1)}%)`
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          color: 'hsl(214.3, 31.8%, 91.4%)',
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  }

  return (
    <div className="h-[400px]">
      <Bar data={chartData} options={options} />
    </div>
  )
}
